module.exports = __webpack_public_path__ + "img/6.312bd7a7.png";